<script>
import {
  autoSuggestPanelEmits,
  autoSuggestPanelProps,
  useAutoSuggestPanel
} from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import AutoSuggestResult from "@/components/organisms/auto-suggest/auto-suggest-result/mobile";
import Button from "@/components/atoms/button/index";
import StateOverlay from "@/components/molecules/state-overlay";
import Divider from "@/components/atoms/divider";
import HistoryListItem from "@/components/organisms/auto-suggest/history-list-item";
export default {
  name: "AutoSuggestPanel",
  components: {
    Button,
    ListItem,
    List,
    AutoSuggestResult,
    StateOverlay,
    Divider,
    HistoryListItem
  },
  props: {
    ...autoSuggestPanelProps()
  },
  emits: [...autoSuggestPanelEmits()],
  setup(props, context) {
    const { fetchSerchResults, closePanel, preventClosePanel } =
      useAutoSuggestPanel(context, props);
    const windowHeight = window.innerHeight;
    const autoSuggestionHeight = computed(() => {
      return {
        height: windowHeight - 70 + "px"
      };
    });
    return {
      autoSuggestionHeight,
      fetchSerchResults,
      closePanel,
      preventClosePanel
    };
  }
};
</script>

<template>
  <div>
    <StateOverlay
      ref="stateOverlay"
      :is-loading="autosuggestIsLoading || historyLoading"
      size="s"
    >
      <AutoSuggestResult
        v-if="categories && categories.length>0 || shops && shops.length>0 || products && products.length>0"
        :categories="categories"
        :products="products"
        :key-word="keyWord"
        :shops="shops"
        :is-national="isNational"
        :header-light="headerLight"
        :word-suggestions="wordSuggestions"
        @selectWordSuggestion="$emit('selectWordSuggestion')"
      />
      <div
        v-else
        :style="autoSuggestionHeight"
        class="c-auto-suggest-panel-mobile__popular"
      >
        <div v-if="historyWords.length > 0">
          <p class="c-auto-suggest-panel-mobile__popular-title u-pl-sm u-pr-sm u-pt-md">
            Historique de vos recherches
          </p>
          <div class="u-flex u-flex-column u-mb-sm u-pl-sm u-pr-sm">
            <List class="u-flex u-flex-column u-gap-sm ">
              <ListItem
                v-for="item in historyWords"
                :key="item"
              >
                <HistoryListItem
                  :key-word="item"
                  @remove="(value) => $emit('removeWordInHistory', value)"
                />
              </ListItem>
            </List>
            <Button
              link
              variant="grey-1"
              icon-color-hover="primary-light"
              class="u-flex-self-end u-mt-md"
              @click="$emit('removeSearchHistory')"
            >
              Supprimer mon historique
            </Button>
          </div>
        </div>
        <Divider
          v-if="historyWords.length > 0"
          class="u-mx-none u-my-lg"
        />
        <p
          v-if="suggestionWords.length > 0"
          class="c-auto-suggest-panel-mobile__popular-title u-pl-sm u-pr-sm"
        >
          Recherches populaires
        </p>
        <div class="u-mb-sm u-pl-sm u-pr-sm">
          <List>
            <ListItem
              v-for="(item, index) in suggestionWords"
              :key="index+item"
            >
              <Button
                :to="'/recherche?keywords='+item"
                class="c-auto-suggest-panel-mobile__list-item"
              >
                {{ item }}
              </Button>
            </ListItem>
          </List>
        </div>
      </div>
    </StateOverlay>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/auto-suggest-panel.scss";
</style>
